import { TestIds } from "constants/test-ids";

export type MobileMenuTestIdsConfigType = {
    firstCTA: string;
    secondCTA: string;
    hamburger: string;
};

export const mobileMenuTestIdsConfig: MobileMenuTestIdsConfigType = {
    firstCTA: TestIds.MOBILE_MENU_FIRST_CTA,
    secondCTA: TestIds.MOBILE_MENU_SECOND_CTA,
    hamburger: TestIds.MOBILE_MENU_HAMBURGER,
};
